import { Component } from '@angular/core';

@Component({
  selector: 'app-sample-styles',
  templateUrl: './sample-styles.component.html',
  styleUrl: './sample-styles.component.scss'
})
export class SampleStylesComponent {}
